// Export main before requiring any modules. This way the modules get main
// instance correctly.
let main = new mainClass()
export default main

import ajax from 'libraries/ajax'
import componentInit from 'components/componentInit'
import $ from 'jQuery'

import 'components/anchorLink'
import 'components/cookieNotice'
import 'components/dialog'
import 'components/encrypted'
import 'components/externalLink'
import 'components/fileLink'
import 'components/form'
import 'components/help'
import 'components/highlightButtons'
import 'components/login'
import 'components/logo'
import 'components/lukukuumeForm'
import 'components/mainMenuButton'
import 'components/oEmbed'
import 'components/polls'
import 'components/searchInput'
import 'components/searchResults'
import 'components/shareButtons'

// Require stylesheets. This enables Webpack’s hot module replacement.
import 'styles/loader.less'

// babel-polyfill is required for IE compatibility. Without the polyfill, IE
// will complain about Symbol being undefined.
import 'babel-polyfill'

// Main class.
function mainClass()
{
  // Variable to hold data loaded from the backend framework with AJAX.
  this.framework = null

  this.run = function()
  {
    // Set error handler.
    window.onerror = this.errorHandler

    // Load backend framework data.
    this.loadBackendData((aq) =>
    {
      // Prepare the application.
      this.prepare(aq)
    })
  }

  // Load backend data.
  // callback:function
  this.loadBackendData = function(callback)
  {
    // Load data from the backend framework with AJAX.
    let query = new ajax.query({
      url: '?r=ajax'
    })

    query.run(() =>
    {
      // Save data to variable.
      if(typeof(query.response.ajax) !== 'undefined')
        this.framework = query.response.ajax

      if(typeof(callback) === 'function')
        callback(query)
    })
  }

  // Prepare application.
  this.prepare = function(aq)
  {
    if(!aq.status)
      return false

    $(document).ready(() =>
    {
      new componentInit($('body')).run()
    })
  }

  // Method for handling errors. Triggered by window.onerror.
  // message:string, url:string, lineNumber:integer
  this.errorHandler = function(message, url, lineNumber)
  {
    // Error data.
    let input = {
      'errors': {
        0: {
          'message': message,
          'file': url,
          'line': lineNumber
        }
      }
    }

    // We do not want an endless error loop. Ignore all errors created by
    // errorHandler().
    let errorHandler = window.onerror
    window.onerror = function() { return true }

    // Send the error to the backend using AJAX.
    let query = new ajax.query({
      url: '?r=ajax/error',
      type: 'POST',
      input: input
    })

    query.run(function()
    {
      window.onerror = errorHandler
    })

    // Suppress the error and continue as normal.
    //return true

    // Let the browser handle the error.
    return false
  }
}

main.run()



// WEBPACK FOOTER //
// ./applications/publicFrontend/scripts/main.js